import { render } from "./TableElement.vue?vue&type=template&id=6f38802a"
import script from "./TableElement.vue?vue&type=script&lang=js"
export * from "./TableElement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__